var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};


//////////////////
// WEBPACK FOOTER
// ./~/react-google-recaptcha/~/core-js/library/modules/$.cof.js
// module id = 691
// module chunks = 0